// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { SearchSymbolResultItem } from "../../../Libs/TradingViewChart/charting_library_cloned_data/charting_library/charting_library";

export class TvSearchSymbolResultItem implements SearchSymbolResultItem
{
    public description: string;
    public exchange: string;
    public full_name: string;
    public symbol: string;
    public ticker: string;
    public type: string;

    public logo_urls?: [string] | [string, string];
    public exchange_logo?: string;
}